import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import VeilederStegComponent from '../../Shared/Scripts/Components/VeilederStegComponent';
import StegValgModell from '../Models/StegValgModell';
import StegModell from '../Models/StegModell';
import ModalVindu from '../Components/ModalVindu';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';
import { AppState } from '../../Shared/Scripts/Store/Types';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

interface StegProps {
    sporsmalId: string
    steg: StegModell,
    onChange: any,
    valgtSteg: StegValgModell[],
    isCollapsable: boolean
}

type VisningProps = StegProps & MapDispatchToProps;

function Steg(props: VisningProps): JSX.Element {
    const stegLenke = new URL(props.steg.stegLenke, window.location.origin).toString();

    function collapseNow(): boolean {

        if(props.valgtSteg == null || !props.isCollapsable) {
            return false;
        }

        if(props.valgtSteg.filter(function (w) { 
                                                return (w.valgtId === props.steg.radiotekst1_koblet_barn ||
                                                        w.valgtId === props.steg.radiotekst2_koblet_barn ||
                                                        w.valgtId === props.steg.radiotekst3_koblet_barn ||
                                                        w.valgtId === props.steg.radiotekst4_koblet_barn ||
                                                        w.valgtId === props.steg.radiotekst5_koblet_barn ||
                                                        w.valgtId === props.steg.radiotekst6_koblet_barn);
                                                })?.length > 0) 
        {
            return true;
        }

        return false;
    }
    collapseNow();

    function hentValgtRadioknappLedetekst(): string {

        if(!props.isCollapsable)
            return "";
        let inputs = document.querySelectorAll('input[name=radioknapp-' + props.sporsmalId +']:checked')

        if(inputs !== null && inputs.length > 0 )
            return inputs[0].getAttribute("data-text") as string;

        return "";
    }

    function radioClickHandler(e: React.ChangeEvent<HTMLInputElement>) {
        props.stegVisningSetCollapsed({id: props.sporsmalId, isCollapsed:true});
        props.onChange(parseInt(e.currentTarget.value));
    }

    function hentRadioknapper(): JSX.Element[] | null {
        let html: JSX.Element[] = [];
        
        if(props.steg.radiotekst1 !== null && props.steg.radiotekst1 !== undefined && props.steg.radiotekst1 !== "") {
            html.push(<div key={1} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst1} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-1-" + props.steg.radiotekst1_koblet_barn} value={props.steg.radiotekst1_koblet_barn} />
                            <label htmlFor={"radio-1-" + props.steg.radiotekst1_koblet_barn}>
                                <span>{props.steg.radiotekst1}</span>
                            </label>
                        </div>);
        }
        if(props.steg.radiotekst2 !== null && props.steg.radiotekst2 !== undefined && props.steg.radiotekst2 !== "") {
            html.push(<div key={2} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst2} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-2-" + props.steg.radiotekst2_koblet_barn} value={props.steg.radiotekst2_koblet_barn} />
                            <label htmlFor={"radio-2-" + props.steg.radiotekst2_koblet_barn}>
                                <span>{props.steg.radiotekst2}</span>
                            </label>
                        </div>);
        }

        if(props.steg.radiotekst3 !== null && props.steg.radiotekst3 !== undefined && props.steg.radiotekst3 !== "") {
            html.push(<div key={3} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst3} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-3-" + props.steg.radiotekst3_koblet_barn} value={props.steg.radiotekst3_koblet_barn} />
                            <label htmlFor={"radio-3-" + props.steg.radiotekst3_koblet_barn}>
                                <span>{props.steg.radiotekst3}</span>
                            </label>
                        </div>);
        }

        if(props.steg.radiotekst4 !== null && props.steg.radiotekst4 !== undefined && props.steg.radiotekst4 !== "") {
            html.push(<div key={4} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst4} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-4-" + props.steg.radiotekst4_koblet_barn} value={props.steg.radiotekst4_koblet_barn} />
                            <label htmlFor={"radio-4-" + props.steg.radiotekst4_koblet_barn}>
                                <span>{props.steg.radiotekst4}</span>
                            </label>
                        </div>);
        }

        if(props.steg.radiotekst5 !== null && props.steg.radiotekst5 !== undefined && props.steg.radiotekst5 !== "") {
            html.push(<div key={5} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst5} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-5-" + props.steg.radiotekst5_koblet_barn} value={props.steg.radiotekst5_koblet_barn} />
                            <label htmlFor={"radio-5-" + props.steg.radiotekst5_koblet_barn}>
                                <span>{props.steg.radiotekst5}</span>
                            </label>
                        </div>);
        }

        if(props.steg.radiotekst6 !== null && props.steg.radiotekst6 !== undefined && props.steg.radiotekst6 !== "") {
            html.push(<div key={6} className="c-radio-input">
                            <input onChange={radioClickHandler} data-text={props.steg.radiotekst6} type="radio" name={"radioknapp-" + props.sporsmalId} id={"radio-6-" + props.steg.radiotekst6_koblet_barn} value={props.steg.radiotekst6_koblet_barn} />
                            <label htmlFor={"radio-6-" + props.steg.radiotekst6_koblet_barn}>
                                <span>{props.steg.radiotekst6}</span>
                            </label>
                        </div>);
        }
        
        return html;
    }

    function hentResultatBokser(): JSX.Element[] | null {

        useEffect(() => {
            updateLiveMessage();
        }, []);
    
        
        let html: JSX.Element[] = [];

        if(props.steg.resultatBokser == null || props.steg.resultatBokser == undefined || props.steg.resultatBokser.length <= 0)
            return null;

        for(let i = 0;i<props.steg.resultatBokser.length;i++) {
            html.push(<div key={i} className="c-veileder__panel-row c-veileder__panel---secondary c-veileder__panel---secondary-lilac">
                    <h3 className="c-veileder__content--venstre">{props.steg.resultatBokser[i].overskrift}</h3>
                    <div className="c-veileder__content--hoyre" dangerouslySetInnerHTML={{__html: props.steg.resultatBokser[i].tekst.value}} />
            </div>);
        }

        return html;
    }

    function hentResultatLenkerContainer(): JSX.Element | null {

        if(props.steg.resultatLenker == null || props.steg.resultatLenker == undefined || props.steg.resultatLenker.length <= 0)
            return null;

        return <div className="c-veileder__panel c-veileder__generell-resultat-hvit"> 
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content--fullwidth">
                    <h3 className="c-veileder-liste__panel-header">{props.steg.resultatLenkeOverskrift}</h3>
                    <ul className="c-veileder-liste__panel c-veileder-liste__panel--links c-veileder--kontainer">
                        {hentResultatLenker()}
                    </ul>
                </div>
            </div>
        </div>
    }

    function hentResultatLenker(): JSX.Element[] | null {
        let html: JSX.Element[] = [];

        for(let i = 0;i<props.steg.resultatLenker.length;i++) {
            html.push(
                <li key={i}>
                    <a href={props.steg.resultatLenker[i].url} className="c-knapp c-knapp--lenke c-knapp--artikkellenke c-knapp--icon-after c-knapp--pil-hoyre-aubergine">{props.steg.resultatLenker[i].tekst}</a>
                </li>
            );
        }

        return html;
    }

    async function stegLenkeKopierClickHandler() {
        try {
            await navigator.clipboard.writeText(stegLenke);
        } catch {
            // Fallback for nettlesere som ikke støtter Clipboard API
            const copyKey = /mac os x/i.test(navigator.userAgent) ? '⌘' : 'Ctrl';
            const text = document.documentElement.lang === 'en-US' ? 'Copy to clipboard' : 'Kopier til utklippstavle';
            const message = `${text}: ${copyKey}+C, Enter`;
            window.prompt(message, stegLenke);
        }
    }

    function hentHtml(): JSX.Element {
        if(props.steg.erResultat) {
            return  <div className="c-veileder__panel c-veileder__panel-paddingBottom-killer c-veileder__panel--lilac">
                        <div className="c-veileder__panel-row">
                            {props.steg.resultatStegKopierKnappTekst !== "" &&
                            <div className="c-veileder__content--fullwidth c-veileder--tekst-margin c-veileder--kopieringslenke-container">
                                <button onClick={stegLenkeKopierClickHandler} className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine">{props.steg.resultatStegKopierKnappTekst}</button> 
                            </div>}
                            <div className="c-veileder__content--fullwidth">
                                <h2 className="c-veileder--overskrift c-veileder--overskrift-stor">{props.steg.resultatOverskrift}</h2>
                            </div>
                            <div className="c-veileder__content--fullwidth">
                                <div className="c-veileder--tekstomraade" >
                                    <div dangerouslySetInnerHTML={{__html: props.steg.resultatTekstTopp?.value || ""}} />
                                    {props.steg.aapneModalVinduLenketekst &&
                                        <ModalVindu
                                            tittel = {props.steg.modalVinduTittel}
                                            brodtekst = {props.steg.modalVinduTekst}
                                            visModalLenkeTekst = {props.steg.aapneModalVinduLenketekst}
                                            lukkModalLenkeTekst = {props.steg.lukkModalVinduLenketekst}
                                            cssClass = {"c-knapp c-knapp--lenke c-knapp--lenke-aubergine"}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                        {hentResultatBokser()}
                        {props.steg.resultatCtaLenketekst != null && props.steg.resultatCtaLenketekst != "" &&
                            <div className="c-veileder__knapp-container"><a href={props.steg.resultatCtaLenke} className="c-knapp c-knapp--cta c-knapp--primary">{props.steg.resultatCtaLenketekst}</a></div>
                        }
                        {hentResultatLenkerContainer()}
                    </div>
        }

        return  <VeilederStegComponent
                    sporsmalId={props.sporsmalId}
                    tittel={<div>{props.steg.overskrift}</div>}
                    forklaring={<div>
                            <div dangerouslySetInnerHTML={{__html: props.steg.ingress?.value}} />
                            {props.steg.aapneModalVinduLenketekst &&
                                <ModalVindu
                                    tittel = {props.steg.modalVinduTittel}
                                    brodtekst = {props.steg.modalVinduTekst}
                                    visModalLenkeTekst = {props.steg.aapneModalVinduLenketekst}
                                    lukkModalLenkeTekst = {props.steg.lukkModalVinduLenketekst}
                                    cssClass = {"c-knapp c-knapp--lenke c-knapp--lenke-aubergine"}
                                />
                            }
                        </div>}
                    inputArea={
                        <div className="c-veileder__inputomrade">
                            <fieldset className="c-veileder__fieldset">
                                <legend>
                                    <p className="c-veileder__undersporsmal">{props.steg.sporsmal}</p>
                                </legend>
                                {hentRadioknapper()}
                            </fieldset>
                        </div>
                    }
                    displayElement={<div className="c-veileder__valgt-item"><span className="c-veileder__tekst c-veileder__tekst--valg">{hentValgtRadioknappLedetekst()}</span></div>}
                    canCollapse={collapseNow()}
                />
    }

    return (
        hentHtml()
    )
}

interface MapStateToProps {
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: AppState, ownProps: StegProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg);
